// extracted by mini-css-extract-plugin
var _1 = "#4c4c4c";
var _2 = "controls_cashoutwrapper__8p69l";
var _3 = "controls_content__9mpfg";
var _4 = "controls_controldot__ybceh";
var _5 = "640px";
var _6 = "790px";
var _7 = "#057676";
var _8 = "controls_full__grft0";
var _9 = "#434343";
var _a = "controls_item__pbdiu";
var _b = "controls_itemlabel__oni9h";
var _c = "controls_line__8p0l3";
var _d = "controls_mask__jssnl";
var _e = "79px";
var _f = "110px";
var _10 = "72px";
var _11 = "665px";
var _12 = "controls_optional__gr8pp";
var _13 = "teal";
var _14 = "controls_timelinecontent__-ads+";
var _15 = "2";
var _16 = "#cdd3dc";
var _17 = "controls_wrapper__4pbd+";
export { _1 as "body", _2 as "cashOutWrapper", _3 as "content", _4 as "controlDot", _5 as "controlsMobileWidth", _6 as "controlsStackedWidth", _7 as "darkTeal", _8 as "full", _9 as "headline", _a as "item", _b as "itemLabel", _c as "line", _d as "mask", _e as "menuHeight", _f as "menuHeightLarge", _10 as "menuHeightMobile", _11 as "modalMobileWidth", _12 as "optional", _13 as "teal", _14 as "timelineContent", _15 as "timelineStrokeWidth", _16 as "timelineTrackColor", _17 as "wrapper" }
